import { FeatureReader as It, FeatureWriter as Dt, LogReader as Mt } from "@farmart-engineering/brave-ship";
import { ConditionBuilder as Vc, FeatureBuilder as Hc, FeatureReader as Yc, FeatureWriter as zc, LogReader as Kc, RolloutStrategyBuilder as qc } from "@farmart-engineering/brave-ship";
import xr, { createContext as be, useState as k, useRef as Ar, useCallback as G, useMemo as ye, useEffect as se, useContext as $e } from "react";
var pe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Lt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Le = { exports: {} }, ne = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fr;
function kt() {
  if (fr) return ne;
  fr = 1;
  var e = xr, r = Symbol.for("react.element"), a = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, l = { key: !0, ref: !0, __self: !0, __source: !0 };
  function f(u, c, v) {
    var p, b = {}, h = null, j = null;
    v !== void 0 && (h = "" + v), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (j = c.ref);
    for (p in c) n.call(c, p) && !l.hasOwnProperty(p) && (b[p] = c[p]);
    if (u && u.defaultProps) for (p in c = u.defaultProps, c) b[p] === void 0 && (b[p] = c[p]);
    return { $$typeof: r, type: u, key: h, ref: j, props: b, _owner: i.current };
  }
  return ne.Fragment = a, ne.jsx = f, ne.jsxs = f, ne;
}
var oe = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vr;
function Wt() {
  return vr || (vr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = xr, r = Symbol.for("react.element"), a = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), l = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), u = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), b = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), j = Symbol.for("react.offscreen"), I = Symbol.iterator, D = "@@iterator";
    function ce(t) {
      if (t === null || typeof t != "object")
        return null;
      var o = I && t[I] || t[D];
      return typeof o == "function" ? o : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function $(t) {
      {
        for (var o = arguments.length, s = new Array(o > 1 ? o - 1 : 0), d = 1; d < o; d++)
          s[d - 1] = arguments[d];
        W("error", t, s);
      }
    }
    function W(t, o, s) {
      {
        var d = C.ReactDebugCurrentFrame, y = d.getStackAddendum();
        y !== "" && (o += "%s", s = s.concat([y]));
        var m = s.map(function(_) {
          return String(_);
        });
        m.unshift("Warning: " + o), Function.prototype.apply.call(console[t], console, m);
      }
    }
    var H = !1, M = !1, U = !1, w = !1, F = !1, Y;
    Y = Symbol.for("react.module.reference");
    function x(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === n || t === l || F || t === i || t === v || t === p || w || t === j || H || M || U || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === b || t.$$typeof === f || t.$$typeof === u || t.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function it(t, o, s) {
      var d = t.displayName;
      if (d)
        return d;
      var y = o.displayName || o.name || "";
      return y !== "" ? s + "(" + y + ")" : s;
    }
    function Ne(t) {
      return t.displayName || "Context";
    }
    function L(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && $("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case n:
          return "Fragment";
        case a:
          return "Portal";
        case l:
          return "Profiler";
        case i:
          return "StrictMode";
        case v:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            var o = t;
            return Ne(o) + ".Consumer";
          case f:
            var s = t;
            return Ne(s._context) + ".Provider";
          case c:
            return it(t, t.render, "ForwardRef");
          case b:
            var d = t.displayName || null;
            return d !== null ? d : L(t.type) || "Memo";
          case h: {
            var y = t, m = y._payload, _ = y._init;
            try {
              return L(_(m));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var N = Object.assign, re = 0, Be, Ve, He, Ye, ze, Ke, qe;
    function Je() {
    }
    Je.__reactDisabledLog = !0;
    function st() {
      {
        if (re === 0) {
          Be = console.log, Ve = console.info, He = console.warn, Ye = console.error, ze = console.group, Ke = console.groupCollapsed, qe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Je,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        re++;
      }
    }
    function ut() {
      {
        if (re--, re === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: N({}, t, {
              value: Be
            }),
            info: N({}, t, {
              value: Ve
            }),
            warn: N({}, t, {
              value: He
            }),
            error: N({}, t, {
              value: Ye
            }),
            group: N({}, t, {
              value: ze
            }),
            groupCollapsed: N({}, t, {
              value: Ke
            }),
            groupEnd: N({}, t, {
              value: qe
            })
          });
        }
        re < 0 && $("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = C.ReactCurrentDispatcher, je;
    function le(t, o, s) {
      {
        if (je === void 0)
          try {
            throw Error();
          } catch (y) {
            var d = y.stack.trim().match(/\n( *(at )?)/);
            je = d && d[1] || "";
          }
        return `
` + je + t;
      }
    }
    var Se = !1, fe;
    {
      var ct = typeof WeakMap == "function" ? WeakMap : Map;
      fe = new ct();
    }
    function Xe(t, o) {
      if (!t || Se)
        return "";
      {
        var s = fe.get(t);
        if (s !== void 0)
          return s;
      }
      var d;
      Se = !0;
      var y = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var m;
      m = we.current, we.current = null, st();
      try {
        if (o) {
          var _ = function() {
            throw Error();
          };
          if (Object.defineProperty(_.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(_, []);
            } catch (P) {
              d = P;
            }
            Reflect.construct(t, [], _);
          } else {
            try {
              _.call();
            } catch (P) {
              d = P;
            }
            t.call(_.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (P) {
            d = P;
          }
          t();
        }
      } catch (P) {
        if (P && d && typeof P.stack == "string") {
          for (var g = P.stack.split(`
`), S = d.stack.split(`
`), O = g.length - 1, E = S.length - 1; O >= 1 && E >= 0 && g[O] !== S[E]; )
            E--;
          for (; O >= 1 && E >= 0; O--, E--)
            if (g[O] !== S[E]) {
              if (O !== 1 || E !== 1)
                do
                  if (O--, E--, E < 0 || g[O] !== S[E]) {
                    var A = `
` + g[O].replace(" at new ", " at ");
                    return t.displayName && A.includes("<anonymous>") && (A = A.replace("<anonymous>", t.displayName)), typeof t == "function" && fe.set(t, A), A;
                  }
                while (O >= 1 && E >= 0);
              break;
            }
        }
      } finally {
        Se = !1, we.current = m, ut(), Error.prepareStackTrace = y;
      }
      var K = t ? t.displayName || t.name : "", B = K ? le(K) : "";
      return typeof t == "function" && fe.set(t, B), B;
    }
    function lt(t, o, s) {
      return Xe(t, !1);
    }
    function ft(t) {
      var o = t.prototype;
      return !!(o && o.isReactComponent);
    }
    function ve(t, o, s) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Xe(t, ft(t));
      if (typeof t == "string")
        return le(t);
      switch (t) {
        case v:
          return le("Suspense");
        case p:
          return le("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case c:
            return lt(t.render);
          case b:
            return ve(t.type, o, s);
          case h: {
            var d = t, y = d._payload, m = d._init;
            try {
              return ve(m(y), o, s);
            } catch {
            }
          }
        }
      return "";
    }
    var te = Object.prototype.hasOwnProperty, Ze = {}, Qe = C.ReactDebugCurrentFrame;
    function de(t) {
      if (t) {
        var o = t._owner, s = ve(t.type, t._source, o ? o.type : null);
        Qe.setExtraStackFrame(s);
      } else
        Qe.setExtraStackFrame(null);
    }
    function vt(t, o, s, d, y) {
      {
        var m = Function.call.bind(te);
        for (var _ in t)
          if (m(t, _)) {
            var g = void 0;
            try {
              if (typeof t[_] != "function") {
                var S = Error((d || "React class") + ": " + s + " type `" + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[_] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw S.name = "Invariant Violation", S;
              }
              g = t[_](o, _, d, s, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (O) {
              g = O;
            }
            g && !(g instanceof Error) && (de(y), $("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", d || "React class", s, _, typeof g), de(null)), g instanceof Error && !(g.message in Ze) && (Ze[g.message] = !0, de(y), $("Failed %s type: %s", s, g.message), de(null));
          }
      }
    }
    var dt = Array.isArray;
    function Pe(t) {
      return dt(t);
    }
    function pt(t) {
      {
        var o = typeof Symbol == "function" && Symbol.toStringTag, s = o && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return s;
      }
    }
    function gt(t) {
      try {
        return er(t), !1;
      } catch {
        return !0;
      }
    }
    function er(t) {
      return "" + t;
    }
    function rr(t) {
      if (gt(t))
        return $("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", pt(t)), er(t);
    }
    var ae = C.ReactCurrentOwner, ht = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, tr, ar, Fe;
    Fe = {};
    function _t(t) {
      if (te.call(t, "ref")) {
        var o = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (o && o.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bt(t) {
      if (te.call(t, "key")) {
        var o = Object.getOwnPropertyDescriptor(t, "key").get;
        if (o && o.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function yt(t, o) {
      if (typeof t.ref == "string" && ae.current && o && ae.current.stateNode !== o) {
        var s = L(ae.current.type);
        Fe[s] || ($('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', L(ae.current.type), t.ref), Fe[s] = !0);
      }
    }
    function $t(t, o) {
      {
        var s = function() {
          tr || (tr = !0, $("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", o));
        };
        s.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: s,
          configurable: !0
        });
      }
    }
    function mt(t, o) {
      {
        var s = function() {
          ar || (ar = !0, $("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", o));
        };
        s.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: s,
          configurable: !0
        });
      }
    }
    var Tt = function(t, o, s, d, y, m, _) {
      var g = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: o,
        ref: s,
        props: _,
        // Record the component responsible for creating this element.
        _owner: m
      };
      return g._store = {}, Object.defineProperty(g._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(g, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: d
      }), Object.defineProperty(g, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
    };
    function Ct(t, o, s, d, y) {
      {
        var m, _ = {}, g = null, S = null;
        s !== void 0 && (rr(s), g = "" + s), bt(o) && (rr(o.key), g = "" + o.key), _t(o) && (S = o.ref, yt(o, y));
        for (m in o)
          te.call(o, m) && !ht.hasOwnProperty(m) && (_[m] = o[m]);
        if (t && t.defaultProps) {
          var O = t.defaultProps;
          for (m in O)
            _[m] === void 0 && (_[m] = O[m]);
        }
        if (g || S) {
          var E = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          g && $t(_, E), S && mt(_, E);
        }
        return Tt(t, g, S, y, d, ae.current, _);
      }
    }
    var xe = C.ReactCurrentOwner, nr = C.ReactDebugCurrentFrame;
    function z(t) {
      if (t) {
        var o = t._owner, s = ve(t.type, t._source, o ? o.type : null);
        nr.setExtraStackFrame(s);
      } else
        nr.setExtraStackFrame(null);
    }
    var Ae;
    Ae = !1;
    function Ie(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function or() {
      {
        if (xe.current) {
          var t = L(xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Ot(t) {
      return "";
    }
    var ir = {};
    function Rt(t) {
      {
        var o = or();
        if (!o) {
          var s = typeof t == "string" ? t : t.displayName || t.name;
          s && (o = `

Check the top-level render call using <` + s + ">.");
        }
        return o;
      }
    }
    function sr(t, o) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var s = Rt(o);
        if (ir[s])
          return;
        ir[s] = !0;
        var d = "";
        t && t._owner && t._owner !== xe.current && (d = " It was passed a child from " + L(t._owner.type) + "."), z(t), $('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', s, d), z(null);
      }
    }
    function ur(t, o) {
      {
        if (typeof t != "object")
          return;
        if (Pe(t))
          for (var s = 0; s < t.length; s++) {
            var d = t[s];
            Ie(d) && sr(d, o);
          }
        else if (Ie(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var y = ce(t);
          if (typeof y == "function" && y !== t.entries)
            for (var m = y.call(t), _; !(_ = m.next()).done; )
              Ie(_.value) && sr(_.value, o);
        }
      }
    }
    function Et(t) {
      {
        var o = t.type;
        if (o == null || typeof o == "string")
          return;
        var s;
        if (typeof o == "function")
          s = o.propTypes;
        else if (typeof o == "object" && (o.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        o.$$typeof === b))
          s = o.propTypes;
        else
          return;
        if (s) {
          var d = L(o);
          vt(s, t.props, "prop", d, t);
        } else if (o.PropTypes !== void 0 && !Ae) {
          Ae = !0;
          var y = L(o);
          $("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", y || "Unknown");
        }
        typeof o.getDefaultProps == "function" && !o.getDefaultProps.isReactClassApproved && $("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function wt(t) {
      {
        for (var o = Object.keys(t.props), s = 0; s < o.length; s++) {
          var d = o[s];
          if (d !== "children" && d !== "key") {
            z(t), $("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", d), z(null);
            break;
          }
        }
        t.ref !== null && (z(t), $("Invalid attribute `ref` supplied to `React.Fragment`."), z(null));
      }
    }
    var cr = {};
    function lr(t, o, s, d, y, m) {
      {
        var _ = x(t);
        if (!_) {
          var g = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (g += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var S = Ot();
          S ? g += S : g += or();
          var O;
          t === null ? O = "null" : Pe(t) ? O = "array" : t !== void 0 && t.$$typeof === r ? (O = "<" + (L(t.type) || "Unknown") + " />", g = " Did you accidentally export a JSX literal instead of a component?") : O = typeof t, $("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", O, g);
        }
        var E = Ct(t, o, s, y, m);
        if (E == null)
          return E;
        if (_) {
          var A = o.children;
          if (A !== void 0)
            if (d)
              if (Pe(A)) {
                for (var K = 0; K < A.length; K++)
                  ur(A[K], t);
                Object.freeze && Object.freeze(A);
              } else
                $("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ur(A, t);
        }
        if (te.call(o, "key")) {
          var B = L(t), P = Object.keys(o).filter(function(At) {
            return At !== "key";
          }), De = P.length > 0 ? "{key: someKey, " + P.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!cr[B + De]) {
            var xt = P.length > 0 ? "{" + P.join(": ..., ") + ": ...}" : "{}";
            $(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, De, B, xt, B), cr[B + De] = !0;
          }
        }
        return t === n ? wt(E) : Et(E), E;
      }
    }
    function jt(t, o, s) {
      return lr(t, o, s, !0);
    }
    function St(t, o, s) {
      return lr(t, o, s, !1);
    }
    var Pt = St, Ft = jt;
    oe.Fragment = n, oe.jsx = Pt, oe.jsxs = Ft;
  }()), oe;
}
process.env.NODE_ENV === "production" ? Le.exports = kt() : Le.exports = Wt();
var R = Le.exports;
function Gt() {
  this.__data__ = [], this.size = 0;
}
var Ut = Gt;
function Nt(e, r) {
  return e === r || e !== e && r !== r;
}
var me = Nt, Bt = me;
function Vt(e, r) {
  for (var a = e.length; a--; )
    if (Bt(e[a][0], r))
      return a;
  return -1;
}
var Te = Vt, Ht = Te, Yt = Array.prototype, zt = Yt.splice;
function Kt(e) {
  var r = this.__data__, a = Ht(r, e);
  if (a < 0)
    return !1;
  var n = r.length - 1;
  return a == n ? r.pop() : zt.call(r, a, 1), --this.size, !0;
}
var qt = Kt, Jt = Te;
function Xt(e) {
  var r = this.__data__, a = Jt(r, e);
  return a < 0 ? void 0 : r[a][1];
}
var Zt = Xt, Qt = Te;
function ea(e) {
  return Qt(this.__data__, e) > -1;
}
var ra = ea, ta = Te;
function aa(e, r) {
  var a = this.__data__, n = ta(a, e);
  return n < 0 ? (++this.size, a.push([e, r])) : a[n][1] = r, this;
}
var na = aa, oa = Ut, ia = qt, sa = Zt, ua = ra, ca = na;
function q(e) {
  var r = -1, a = e == null ? 0 : e.length;
  for (this.clear(); ++r < a; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
q.prototype.clear = oa;
q.prototype.delete = ia;
q.prototype.get = sa;
q.prototype.has = ua;
q.prototype.set = ca;
var Ce = q, la = Ce;
function fa() {
  this.__data__ = new la(), this.size = 0;
}
var va = fa;
function da(e) {
  var r = this.__data__, a = r.delete(e);
  return this.size = r.size, a;
}
var pa = da;
function ga(e) {
  return this.__data__.get(e);
}
var ha = ga;
function _a(e) {
  return this.__data__.has(e);
}
var ba = _a, ya = typeof pe == "object" && pe && pe.Object === Object && pe, Ir = ya, $a = Ir, ma = typeof self == "object" && self && self.Object === Object && self, Ta = $a || ma || Function("return this")(), J = Ta, Ca = J, Oa = Ca.Symbol, Dr = Oa, dr = Dr, Mr = Object.prototype, Ra = Mr.hasOwnProperty, Ea = Mr.toString, ie = dr ? dr.toStringTag : void 0;
function wa(e) {
  var r = Ra.call(e, ie), a = e[ie];
  try {
    e[ie] = void 0;
    var n = !0;
  } catch {
  }
  var i = Ea.call(e);
  return n && (r ? e[ie] = a : delete e[ie]), i;
}
var ja = wa, Sa = Object.prototype, Pa = Sa.toString;
function Fa(e) {
  return Pa.call(e);
}
var xa = Fa, pr = Dr, Aa = ja, Ia = xa, Da = "[object Null]", Ma = "[object Undefined]", gr = pr ? pr.toStringTag : void 0;
function La(e) {
  return e == null ? e === void 0 ? Ma : Da : gr && gr in Object(e) ? Aa(e) : Ia(e);
}
var Oe = La;
function ka(e) {
  var r = typeof e;
  return e != null && (r == "object" || r == "function");
}
var V = ka, Wa = Oe, Ga = V, Ua = "[object AsyncFunction]", Na = "[object Function]", Ba = "[object GeneratorFunction]", Va = "[object Proxy]";
function Ha(e) {
  if (!Ga(e))
    return !1;
  var r = Wa(e);
  return r == Na || r == Ba || r == Ua || r == Va;
}
var ke = Ha, Ya = J, za = Ya["__core-js_shared__"], Ka = za, Me = Ka, hr = function() {
  var e = /[^.]+$/.exec(Me && Me.keys && Me.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function qa(e) {
  return !!hr && hr in e;
}
var Ja = qa, Xa = Function.prototype, Za = Xa.toString;
function Qa(e) {
  if (e != null) {
    try {
      return Za.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var en = Qa, rn = ke, tn = Ja, an = V, nn = en, on = /[\\^$.*+?()[\]{}|]/g, sn = /^\[object .+?Constructor\]$/, un = Function.prototype, cn = Object.prototype, ln = un.toString, fn = cn.hasOwnProperty, vn = RegExp(
  "^" + ln.call(fn).replace(on, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function dn(e) {
  if (!an(e) || tn(e))
    return !1;
  var r = rn(e) ? vn : sn;
  return r.test(nn(e));
}
var pn = dn;
function gn(e, r) {
  return e == null ? void 0 : e[r];
}
var hn = gn, _n = pn, bn = hn;
function yn(e, r) {
  var a = bn(e, r);
  return _n(a) ? a : void 0;
}
var We = yn, $n = We, mn = J, Tn = $n(mn, "Map"), Lr = Tn, Cn = We, On = Cn(Object, "create"), Re = On, _r = Re;
function Rn() {
  this.__data__ = _r ? _r(null) : {}, this.size = 0;
}
var En = Rn;
function wn(e) {
  var r = this.has(e) && delete this.__data__[e];
  return this.size -= r ? 1 : 0, r;
}
var jn = wn, Sn = Re, Pn = "__lodash_hash_undefined__", Fn = Object.prototype, xn = Fn.hasOwnProperty;
function An(e) {
  var r = this.__data__;
  if (Sn) {
    var a = r[e];
    return a === Pn ? void 0 : a;
  }
  return xn.call(r, e) ? r[e] : void 0;
}
var In = An, Dn = Re, Mn = Object.prototype, Ln = Mn.hasOwnProperty;
function kn(e) {
  var r = this.__data__;
  return Dn ? r[e] !== void 0 : Ln.call(r, e);
}
var Wn = kn, Gn = Re, Un = "__lodash_hash_undefined__";
function Nn(e, r) {
  var a = this.__data__;
  return this.size += this.has(e) ? 0 : 1, a[e] = Gn && r === void 0 ? Un : r, this;
}
var Bn = Nn, Vn = En, Hn = jn, Yn = In, zn = Wn, Kn = Bn;
function X(e) {
  var r = -1, a = e == null ? 0 : e.length;
  for (this.clear(); ++r < a; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
X.prototype.clear = Vn;
X.prototype.delete = Hn;
X.prototype.get = Yn;
X.prototype.has = zn;
X.prototype.set = Kn;
var qn = X, br = qn, Jn = Ce, Xn = Lr;
function Zn() {
  this.size = 0, this.__data__ = {
    hash: new br(),
    map: new (Xn || Jn)(),
    string: new br()
  };
}
var Qn = Zn;
function eo(e) {
  var r = typeof e;
  return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? e !== "__proto__" : e === null;
}
var ro = eo, to = ro;
function ao(e, r) {
  var a = e.__data__;
  return to(r) ? a[typeof r == "string" ? "string" : "hash"] : a.map;
}
var Ee = ao, no = Ee;
function oo(e) {
  var r = no(this, e).delete(e);
  return this.size -= r ? 1 : 0, r;
}
var io = oo, so = Ee;
function uo(e) {
  return so(this, e).get(e);
}
var co = uo, lo = Ee;
function fo(e) {
  return lo(this, e).has(e);
}
var vo = fo, po = Ee;
function go(e, r) {
  var a = po(this, e), n = a.size;
  return a.set(e, r), this.size += a.size == n ? 0 : 1, this;
}
var ho = go, _o = Qn, bo = io, yo = co, $o = vo, mo = ho;
function Z(e) {
  var r = -1, a = e == null ? 0 : e.length;
  for (this.clear(); ++r < a; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
Z.prototype.clear = _o;
Z.prototype.delete = bo;
Z.prototype.get = yo;
Z.prototype.has = $o;
Z.prototype.set = mo;
var To = Z, Co = Ce, Oo = Lr, Ro = To, Eo = 200;
function wo(e, r) {
  var a = this.__data__;
  if (a instanceof Co) {
    var n = a.__data__;
    if (!Oo || n.length < Eo - 1)
      return n.push([e, r]), this.size = ++a.size, this;
    a = this.__data__ = new Ro(n);
  }
  return a.set(e, r), this.size = a.size, this;
}
var jo = wo, So = Ce, Po = va, Fo = pa, xo = ha, Ao = ba, Io = jo;
function Q(e) {
  var r = this.__data__ = new So(e);
  this.size = r.size;
}
Q.prototype.clear = Po;
Q.prototype.delete = Fo;
Q.prototype.get = xo;
Q.prototype.has = Ao;
Q.prototype.set = Io;
var Do = Q, Mo = We, Lo = function() {
  try {
    var e = Mo(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), kr = Lo, yr = kr;
function ko(e, r, a) {
  r == "__proto__" && yr ? yr(e, r, {
    configurable: !0,
    enumerable: !0,
    value: a,
    writable: !0
  }) : e[r] = a;
}
var Ge = ko, Wo = Ge, Go = me;
function Uo(e, r, a) {
  (a !== void 0 && !Go(e[r], a) || a === void 0 && !(r in e)) && Wo(e, r, a);
}
var Wr = Uo;
function No(e) {
  return function(r, a, n) {
    for (var i = -1, l = Object(r), f = n(r), u = f.length; u--; ) {
      var c = f[e ? u : ++i];
      if (a(l[c], c, l) === !1)
        break;
    }
    return r;
  };
}
var Bo = No, Vo = Bo, Ho = Vo(), Yo = Ho, ge = { exports: {} };
ge.exports;
(function(e, r) {
  var a = J, n = r && !r.nodeType && r, i = n && !0 && e && !e.nodeType && e, l = i && i.exports === n, f = l ? a.Buffer : void 0, u = f ? f.allocUnsafe : void 0;
  function c(v, p) {
    if (p)
      return v.slice();
    var b = v.length, h = u ? u(b) : new v.constructor(b);
    return v.copy(h), h;
  }
  e.exports = c;
})(ge, ge.exports);
var zo = ge.exports, Ko = J, qo = Ko.Uint8Array, Jo = qo, $r = Jo;
function Xo(e) {
  var r = new e.constructor(e.byteLength);
  return new $r(r).set(new $r(e)), r;
}
var Zo = Xo, Qo = Zo;
function ei(e, r) {
  var a = r ? Qo(e.buffer) : e.buffer;
  return new e.constructor(a, e.byteOffset, e.length);
}
var ri = ei;
function ti(e, r) {
  var a = -1, n = e.length;
  for (r || (r = Array(n)); ++a < n; )
    r[a] = e[a];
  return r;
}
var ai = ti, ni = V, mr = Object.create, oi = /* @__PURE__ */ function() {
  function e() {
  }
  return function(r) {
    if (!ni(r))
      return {};
    if (mr)
      return mr(r);
    e.prototype = r;
    var a = new e();
    return e.prototype = void 0, a;
  };
}(), ii = oi;
function si(e, r) {
  return function(a) {
    return e(r(a));
  };
}
var ui = si, ci = ui, li = ci(Object.getPrototypeOf, Object), Gr = li, fi = Object.prototype;
function vi(e) {
  var r = e && e.constructor, a = typeof r == "function" && r.prototype || fi;
  return e === a;
}
var Ur = vi, di = ii, pi = Gr, gi = Ur;
function hi(e) {
  return typeof e.constructor == "function" && !gi(e) ? di(pi(e)) : {};
}
var _i = hi;
function bi(e) {
  return e != null && typeof e == "object";
}
var ue = bi, yi = Oe, $i = ue, mi = "[object Arguments]";
function Ti(e) {
  return $i(e) && yi(e) == mi;
}
var Ci = Ti, Tr = Ci, Oi = ue, Nr = Object.prototype, Ri = Nr.hasOwnProperty, Ei = Nr.propertyIsEnumerable, wi = Tr(/* @__PURE__ */ function() {
  return arguments;
}()) ? Tr : function(e) {
  return Oi(e) && Ri.call(e, "callee") && !Ei.call(e, "callee");
}, Br = wi, ji = Array.isArray, Vr = ji, Si = 9007199254740991;
function Pi(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Si;
}
var Hr = Pi, Fi = ke, xi = Hr;
function Ai(e) {
  return e != null && xi(e.length) && !Fi(e);
}
var Ue = Ai, Ii = Ue, Di = ue;
function Mi(e) {
  return Di(e) && Ii(e);
}
var Li = Mi, he = { exports: {} };
function ki() {
  return !1;
}
var Wi = ki;
he.exports;
(function(e, r) {
  var a = J, n = Wi, i = r && !r.nodeType && r, l = i && !0 && e && !e.nodeType && e, f = l && l.exports === i, u = f ? a.Buffer : void 0, c = u ? u.isBuffer : void 0, v = c || n;
  e.exports = v;
})(he, he.exports);
var Yr = he.exports, Gi = Oe, Ui = Gr, Ni = ue, Bi = "[object Object]", Vi = Function.prototype, Hi = Object.prototype, zr = Vi.toString, Yi = Hi.hasOwnProperty, zi = zr.call(Object);
function Ki(e) {
  if (!Ni(e) || Gi(e) != Bi)
    return !1;
  var r = Ui(e);
  if (r === null)
    return !0;
  var a = Yi.call(r, "constructor") && r.constructor;
  return typeof a == "function" && a instanceof a && zr.call(a) == zi;
}
var qi = Ki, Ji = Oe, Xi = Hr, Zi = ue, Qi = "[object Arguments]", es = "[object Array]", rs = "[object Boolean]", ts = "[object Date]", as = "[object Error]", ns = "[object Function]", os = "[object Map]", is = "[object Number]", ss = "[object Object]", us = "[object RegExp]", cs = "[object Set]", ls = "[object String]", fs = "[object WeakMap]", vs = "[object ArrayBuffer]", ds = "[object DataView]", ps = "[object Float32Array]", gs = "[object Float64Array]", hs = "[object Int8Array]", _s = "[object Int16Array]", bs = "[object Int32Array]", ys = "[object Uint8Array]", $s = "[object Uint8ClampedArray]", ms = "[object Uint16Array]", Ts = "[object Uint32Array]", T = {};
T[ps] = T[gs] = T[hs] = T[_s] = T[bs] = T[ys] = T[$s] = T[ms] = T[Ts] = !0;
T[Qi] = T[es] = T[vs] = T[rs] = T[ds] = T[ts] = T[as] = T[ns] = T[os] = T[is] = T[ss] = T[us] = T[cs] = T[ls] = T[fs] = !1;
function Cs(e) {
  return Zi(e) && Xi(e.length) && !!T[Ji(e)];
}
var Os = Cs;
function Rs(e) {
  return function(r) {
    return e(r);
  };
}
var Es = Rs, _e = { exports: {} };
_e.exports;
(function(e, r) {
  var a = Ir, n = r && !r.nodeType && r, i = n && !0 && e && !e.nodeType && e, l = i && i.exports === n, f = l && a.process, u = function() {
    try {
      var c = i && i.require && i.require("util").types;
      return c || f && f.binding && f.binding("util");
    } catch {
    }
  }();
  e.exports = u;
})(_e, _e.exports);
var ws = _e.exports, js = Os, Ss = Es, Cr = ws, Or = Cr && Cr.isTypedArray, Ps = Or ? Ss(Or) : js, Kr = Ps;
function Fs(e, r) {
  if (!(r === "constructor" && typeof e[r] == "function") && r != "__proto__")
    return e[r];
}
var qr = Fs, xs = Ge, As = me, Is = Object.prototype, Ds = Is.hasOwnProperty;
function Ms(e, r, a) {
  var n = e[r];
  (!(Ds.call(e, r) && As(n, a)) || a === void 0 && !(r in e)) && xs(e, r, a);
}
var Ls = Ms, ks = Ls, Ws = Ge;
function Gs(e, r, a, n) {
  var i = !a;
  a || (a = {});
  for (var l = -1, f = r.length; ++l < f; ) {
    var u = r[l], c = n ? n(a[u], e[u], u, a, e) : void 0;
    c === void 0 && (c = e[u]), i ? Ws(a, u, c) : ks(a, u, c);
  }
  return a;
}
var Us = Gs;
function Ns(e, r) {
  for (var a = -1, n = Array(e); ++a < e; )
    n[a] = r(a);
  return n;
}
var Bs = Ns, Vs = 9007199254740991, Hs = /^(?:0|[1-9]\d*)$/;
function Ys(e, r) {
  var a = typeof e;
  return r = r ?? Vs, !!r && (a == "number" || a != "symbol" && Hs.test(e)) && e > -1 && e % 1 == 0 && e < r;
}
var Jr = Ys, zs = Bs, Ks = Br, qs = Vr, Js = Yr, Xs = Jr, Zs = Kr, Qs = Object.prototype, eu = Qs.hasOwnProperty;
function ru(e, r) {
  var a = qs(e), n = !a && Ks(e), i = !a && !n && Js(e), l = !a && !n && !i && Zs(e), f = a || n || i || l, u = f ? zs(e.length, String) : [], c = u.length;
  for (var v in e)
    (r || eu.call(e, v)) && !(f && // Safari 9 has enumerable `arguments.length` in strict mode.
    (v == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (v == "offset" || v == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    l && (v == "buffer" || v == "byteLength" || v == "byteOffset") || // Skip index properties.
    Xs(v, c))) && u.push(v);
  return u;
}
var tu = ru;
function au(e) {
  var r = [];
  if (e != null)
    for (var a in Object(e))
      r.push(a);
  return r;
}
var nu = au, ou = V, iu = Ur, su = nu, uu = Object.prototype, cu = uu.hasOwnProperty;
function lu(e) {
  if (!ou(e))
    return su(e);
  var r = iu(e), a = [];
  for (var n in e)
    n == "constructor" && (r || !cu.call(e, n)) || a.push(n);
  return a;
}
var fu = lu, vu = tu, du = fu, pu = Ue;
function gu(e) {
  return pu(e) ? vu(e, !0) : du(e);
}
var Xr = gu, hu = Us, _u = Xr;
function bu(e) {
  return hu(e, _u(e));
}
var yu = bu, Rr = Wr, $u = zo, mu = ri, Tu = ai, Cu = _i, Er = Br, wr = Vr, Ou = Li, Ru = Yr, Eu = ke, wu = V, ju = qi, Su = Kr, jr = qr, Pu = yu;
function Fu(e, r, a, n, i, l, f) {
  var u = jr(e, a), c = jr(r, a), v = f.get(c);
  if (v) {
    Rr(e, a, v);
    return;
  }
  var p = l ? l(u, c, a + "", e, r, f) : void 0, b = p === void 0;
  if (b) {
    var h = wr(c), j = !h && Ru(c), I = !h && !j && Su(c);
    p = c, h || j || I ? wr(u) ? p = u : Ou(u) ? p = Tu(u) : j ? (b = !1, p = $u(c, !0)) : I ? (b = !1, p = mu(c, !0)) : p = [] : ju(c) || Er(c) ? (p = u, Er(u) ? p = Pu(u) : (!wu(u) || Eu(u)) && (p = Cu(c))) : b = !1;
  }
  b && (f.set(c, p), i(p, c, n, l, f), f.delete(c)), Rr(e, a, p);
}
var xu = Fu, Au = Do, Iu = Wr, Du = Yo, Mu = xu, Lu = V, ku = Xr, Wu = qr;
function Zr(e, r, a, n, i) {
  e !== r && Du(r, function(l, f) {
    if (i || (i = new Au()), Lu(l))
      Mu(e, r, f, a, Zr, n, i);
    else {
      var u = n ? n(Wu(e, f), l, f + "", e, r, i) : void 0;
      u === void 0 && (u = l), Iu(e, f, u);
    }
  }, ku);
}
var Gu = Zr;
function Uu(e) {
  return e;
}
var Qr = Uu;
function Nu(e, r, a) {
  switch (a.length) {
    case 0:
      return e.call(r);
    case 1:
      return e.call(r, a[0]);
    case 2:
      return e.call(r, a[0], a[1]);
    case 3:
      return e.call(r, a[0], a[1], a[2]);
  }
  return e.apply(r, a);
}
var Bu = Nu, Vu = Bu, Sr = Math.max;
function Hu(e, r, a) {
  return r = Sr(r === void 0 ? e.length - 1 : r, 0), function() {
    for (var n = arguments, i = -1, l = Sr(n.length - r, 0), f = Array(l); ++i < l; )
      f[i] = n[r + i];
    i = -1;
    for (var u = Array(r + 1); ++i < r; )
      u[i] = n[i];
    return u[r] = a(f), Vu(e, this, u);
  };
}
var Yu = Hu;
function zu(e) {
  return function() {
    return e;
  };
}
var Ku = zu, qu = Ku, Pr = kr, Ju = Qr, Xu = Pr ? function(e, r) {
  return Pr(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: qu(r),
    writable: !0
  });
} : Ju, Zu = Xu, Qu = 800, ec = 16, rc = Date.now;
function tc(e) {
  var r = 0, a = 0;
  return function() {
    var n = rc(), i = ec - (n - a);
    if (a = n, i > 0) {
      if (++r >= Qu)
        return arguments[0];
    } else
      r = 0;
    return e.apply(void 0, arguments);
  };
}
var ac = tc, nc = Zu, oc = ac, ic = oc(nc), sc = ic, uc = Qr, cc = Yu, lc = sc;
function fc(e, r) {
  return lc(cc(e, r, uc), e + "");
}
var vc = fc, dc = me, pc = Ue, gc = Jr, hc = V;
function _c(e, r, a) {
  if (!hc(a))
    return !1;
  var n = typeof r;
  return (n == "number" ? pc(a) && gc(r, a.length) : n == "string" && r in a) ? dc(a[r], e) : !1;
}
var bc = _c, yc = vc, $c = bc;
function mc(e) {
  return yc(function(r, a) {
    var n = -1, i = a.length, l = i > 1 ? a[i - 1] : void 0, f = i > 2 ? a[2] : void 0;
    for (l = e.length > 3 && typeof l == "function" ? (i--, l) : void 0, f && $c(a[0], a[1], f) && (l = i < 3 ? void 0 : l, i = 1), r = Object(r); ++n < i; ) {
      var u = a[n];
      u && e(r, u, n, l);
    }
    return r;
  });
}
var Tc = mc, Cc = Gu, Oc = Tc, Rc = Oc(function(e, r, a) {
  Cc(e, r, a);
}), Ec = Rc;
const Fr = /* @__PURE__ */ Lt(Ec), et = be(void 0), Ic = ({
  featureReaderConfig: e,
  loader: r = null,
  blockRenderingUntilLoaded: a = !1,
  onFeatureFlagEvaluate: n = null,
  autoLoadFeatureFlags: i = !0,
  connection: l = "REST",
  children: f
}) => {
  const [u, c] = k(e), [v, p] = k(null), [b, h] = k(!1), [j, I] = k(null), D = Ar(null), ce = G((w) => {
    c((F) => Fr({}, F, w));
  }, []), C = G((w) => {
    c((F) => F.workspace === w ? F : Fr({}, F, { workspace: w }));
  }, []), $ = ye(() => new It(u), [u]), W = G(() => new Promise((w, F) => {
    var Y;
    l === "WS" ? ((Y = D.current) == null || Y.call(D), D.current = $.subscribeToFeatureFlags(
      (x) => {
        p(x), w(x);
      },
      (x) => {
        I(x), F(x);
      }
    )) : $.getFeatureFlags().then((x) => {
      p(x), w(x);
    }).catch((x) => {
      I(x), F(x);
    });
  }), [l, $]);
  se(() => {
    if (i)
      return h(!0), W().then(() => {
        h(!1);
      }), () => {
        var w;
        (w = D.current) == null || w.call(D);
      };
  }, [W, i]);
  const H = G(
    (w) => (v == null ? void 0 : v[w]) || null,
    [v]
  ), M = G(() => {
    if (l === "WS") {
      console.warn("refetchFeatureFlags usage is prohibited when connection is WS");
      return;
    }
    W();
  }, [l, W]), U = G(async (w) => {
    if (v && v[w])
      return v[w].getIsEnabled();
    const F = await $.getFeatureFlag(w);
    return F ? await F.getIsEnabled() : !1;
  }, [$.getFeatureFlag, v]);
  return a && b ? /* @__PURE__ */ R.jsx(R.Fragment, { children: r }) : /* @__PURE__ */ R.jsx(
    et.Provider,
    {
      value: {
        reader: $,
        onFeatureFlagEvaluate: n,
        features: v,
        refetchFeatureFlags: M,
        loading: b,
        error: j,
        connection: l,
        getFeature: H,
        updateFeatureReaderConfig: ce,
        updateWorkspace: C,
        featureReaderConfig: u,
        getIsFeatureEnabled: U
      },
      children: f
    }
  );
}, ee = () => {
  const e = $e(et);
  if (!e)
    throw new Error("useFeatureReader must be used within a FeatureReaderProvider");
  return e;
}, rt = be(void 0), Dc = ({
  getAuthUser: e,
  children: r
}) => {
  const { featureReaderConfig: a } = ee(), n = ye(() => new Dt({
    firebase: a.firebase,
    workspace: a.workspace,
    getAuthUser: e
  }), [a.firebase, a.workspace, e]);
  return /* @__PURE__ */ R.jsx(rt.Provider, { value: { writer: n }, children: r });
}, Mc = () => {
  const e = $e(rt);
  if (!e)
    throw new Error("useFeatureWriter must be used within a FeatureWriterProvider");
  return e;
}, wc = ({
  featureName: e,
  connection: r,
  scope: a,
  strategy: n
}) => {
  const i = ee(), [l, f] = k(!0), [u, c] = k(!1), [v, p] = k(null);
  return se(() => {
    let b, h;
    const j = (C) => {
      var H;
      if (f(!1), !C) return;
      const $ = C.getIsInMaintenance(a, n) ?? !1, W = $ ? ((H = C.getActiveRelease) == null ? void 0 : H.call(C)) ?? null : null;
      if (h && clearTimeout(h), !$) {
        const M = C.getNextActiveRelease();
        if (M != null && M.downtimeStartAt) {
          const U = new Date(M.downtimeStartAt).getTime() - Date.now();
          console.log("scheduling next release if present", M == null ? void 0 : M.downtimeStartAt, U), U > 0 && (h = setTimeout(() => j(C), U));
        }
      }
      c($), p(W);
    }, I = (C) => {
      console.error("Failed to fetch feature config:", C), f(!1);
    }, D = async () => {
      try {
        const C = await i.reader.getRemoteConfig(e);
        j(C ?? null);
      } catch (C) {
        I(C);
      }
    };
    return (r || i.connection || "REST") === "WS" ? b = i.reader.subscribeToRemoteConfig(
      e,
      j,
      I
    ) : D(), () => {
      b == null || b(), h && clearTimeout(h);
    };
  }, [i.reader, i.connection, e, r, n]), {
    loading: l || i.loading,
    inMaintenance: u,
    releasePlan: v
  };
}, tt = (e) => {
  const r = ee();
  return e || r.featureReaderConfig.workspace || "";
}, Lc = ({
  featureName: e,
  loader: r = null,
  renderMaintenanceWindow: a,
  onDeploymentCompleted: n,
  children: i,
  scope: l,
  strategy: f = "auto",
  connection: u = "REST"
}) => {
  const c = tt(e), v = l || c, { loading: p, inMaintenance: b, releasePlan: h } = wc({ featureName: c, connection: u, strategy: f, scope: v });
  return p ? /* @__PURE__ */ R.jsx(R.Fragment, { children: r }) : b ? /* @__PURE__ */ R.jsx(jc, { strategy: f, onDeploymentCompleted: n, releasePlan: h, renderMaintenanceWindow: a }) : /* @__PURE__ */ R.jsx(R.Fragment, { children: i });
}, jc = ({
  renderMaintenanceWindow: e = () => null,
  releasePlan: r,
  strategy: a,
  onDeploymentCompleted: n
}) => {
  const i = Ar(null);
  i.current = n;
  const l = r == null ? void 0 : r.downtimeEndAt;
  return se(() => {
    if (i.current && l && a === "auto") {
      const f = new Date(l).getTime(), u = Date.now(), c = f - u;
      if (c > 0) {
        const v = setTimeout(() => {
          var p;
          (p = i.current) == null || p.call(i);
        }, c);
        return () => clearTimeout(v);
      }
    }
  }, [l, a]), /* @__PURE__ */ R.jsx(R.Fragment, { children: e(r) });
}, Sc = (e) => {
  const r = ee(), [a, n] = k(null);
  return se(() => {
    r.getIsFeatureEnabled(e).then((i) => {
      n(i), r.onFeatureFlagEvaluate && r.onFeatureFlagEvaluate(e, i);
    });
  }, [r.getIsFeatureEnabled, r.onFeatureFlagEvaluate, e]), a;
}, at = be({ stack: [] }), Pc = ({
  featureName: e,
  loader: r = null,
  fallback: a = null,
  children: n
}) => {
  const i = nt(), l = Sc(e), f = ye(() => {
    const u = { featureName: e };
    return [...i.stack, u];
  }, [i.stack, e]);
  return l === null ? /* @__PURE__ */ R.jsx(R.Fragment, { children: r }) : l ? /* @__PURE__ */ R.jsx(at.Provider, { value: { stack: f }, children: n }) : /* @__PURE__ */ R.jsx(R.Fragment, { children: a });
}, nt = () => $e(at), kc = () => {
  const { stack: e } = nt();
  return e.length > 0 ? e[e.length - 1] : null;
}, Fc = ({ variants: e, loader: r, fallback: a }) => {
  if (e.length === 0) return /* @__PURE__ */ R.jsx(R.Fragment, { children: a });
  const [n, ...i] = e;
  return /* @__PURE__ */ R.jsx(
    Pc,
    {
      featureName: n.featureName,
      loader: r,
      fallback: /* @__PURE__ */ R.jsx(Fc, { variants: i, loader: r, fallback: a }),
      children: n.Component
    }
  );
}, Wc = ({
  fallbackVersion: e = "",
  featureName: r,
  loadingText: a = "",
  connection: n
}) => {
  const i = tt(r), [l, f] = k(a || ""), { reader: u, connection: c } = ee(), v = G((h) => {
    const j = h == null ? void 0 : h.getCurrentVersion();
    f(j ?? e);
  }, [e]), p = G((h) => {
    f(e);
  }, [e]), b = n || c || "REST";
  return se(() => {
    let h;
    return b === "WS" ? h = u.subscribeToRemoteConfig(
      i,
      v,
      p
    ) : u.getRemoteConfig(i).then(v).catch(p), () => {
      h == null || h();
    };
  }, [i, u, b]), l;
}, ot = be(null), Gc = ({ children: e }) => {
  const { featureReaderConfig: r } = ee(), a = ye(() => new Mt(r.firebase, r.workspace), [r.firebase, r.workspace]), n = {
    getLogsForEntity: a.getLogsForEntity.bind(a),
    getAllLogs: a.getAllLogs.bind(a)
  };
  return /* @__PURE__ */ R.jsx(ot.Provider, { value: n, children: e });
}, Uc = () => {
  const e = $e(ot);
  if (!e)
    throw new Error("useLogReader must be used within a LogReaderProvider");
  return e;
};
export {
  Vc as ConditionBuilder,
  Hc as FeatureBuilder,
  Pc as FeatureFlagGate,
  Yc as FeatureReader,
  Ic as FeatureReaderProvider,
  Fc as FeatureVariant,
  zc as FeatureWriter,
  Dc as FeatureWriterProvider,
  Kc as LogReader,
  Gc as LogReaderProvider,
  Lc as MaintenanceWindowGate,
  qc as RolloutStrategyBuilder,
  kc as useCurrentFeatureFlag,
  Sc as useFeatureEnabled,
  nt as useFeatureFlagContext,
  ee as useFeatureReader,
  Wc as useFeatureVersion,
  Mc as useFeatureWriter,
  Uc as useLogReader
};
